import BenchmarkComparisonCard from './BenchmarkComparisonCard'

// AI-CONTEXT: See docs/features/participation-ladder-benchmark.md
//
// "Werkzame elementen" — which mechanisms of change the best presterende
// organisaties inzetten versus de rest. Rows come from the benchmark
// explanation's `mechanisms` dimension: hand-made TOC mechanisms
// (TocMechanisms.Title) + interview-derived MechanismLinks labels per
// organisation, split top-vs-rest server-side. Labels are the mechanism labels
// themselves — no taxonomy lookup needed. Renders nothing without data.

/**
 * @param {object} props
 * @param {object | null} props.explanation - benchmark explanation block; reads `mechanisms` + `sampleSizes`
 */
const BenchmarkMechanismsSection = ({ explanation }) => {
    const block = explanation?.mechanisms
    const rows = block?.rows || []
    if (rows.length === 0) return null

    return (
        <div className='bd-explanation-block'>
            <h2 className='bd-section-heading'>Werkzame elementen</h2>
            <p className='bd-section-sub'>
                Welke werkzame elementen de best presterende organisaties inzetten,
                vergeleken met de overige organisaties. Werkzame elementen komen uit de
                Theory of Change en uit storytelling-interviews.
            </p>

            <div className='bd-explanation-grid'>
                <BenchmarkComparisonCard
                    title='Werkzame elementen'
                    rows={rows}
                    labelFor={(k) => k}
                    coverage={block?.coverage}
                    sampleSizes={explanation.sampleSizes}
                />
            </div>
        </div>
    )
}

export default BenchmarkMechanismsSection
